import type { SVGProps } from 'react';

export function EmailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.33398 6.16732C1.33398 3.83398 2.66732 2.83398 4.66732 2.83398H11.334C13.334 2.83398 14.6673 3.83398 14.6673 6.16732V10.834C14.6673 13.1673 13.334 14.1673 11.334 14.1673H4.66732'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.3327 6.5L9.24601 8.16667C8.55935 8.71333 7.43268 8.71333 6.74601 8.16667L4.66602 6.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.33398 11.5H5.33398'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.33398 8.83398H3.33398'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
